import React from 'react';
import { Facebook, Instagram, Twitter, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-primary text-white border-t border-primary-light pt-16 pb-8" data-id="element-134">
      <div className="container mx-auto px-6 md:px-12" data-id="element-135">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-136">
          {/* Brand */}
          <div className="col-span-1 lg:col-span-1" data-id="element-137">
            <a href="#home" className="text-3xl font-serif font-bold tracking-wider flex items-center gap-2 mb-6" data-id="element-138">
              <img src="https://cdn.magicpatterns.com/uploads/hnobfKEnzyBNrLtuACUKpW/WhatsApp_Image_2026-04-20_at_12.48.43_AM_(1).jpg" alt="WC Home Remodeling Logo" className="h-12 w-auto rounded-sm" data-id="element-139" />
              WC Home Remodeling
            </a>
            <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-140">
              Over 20 years transforming homes with quality, transparency, and
              attention to detail. Your vision, our expertise.
            </p>
            <div className="flex gap-4" data-id="element-141">
              <a href="https://www.facebook.com/wilson_remodel" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-sm bg-primary-light flex items-center justify-center hover:bg-accent hover:text-white transition-colors" data-id="element-142">
                <Facebook size={20} data-id="element-143" />
              </a>
              <a href="https://www.instagram.com/wc_homeremodeling_" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-sm bg-primary-light flex items-center justify-center hover:bg-accent hover:text-white transition-colors" data-id="element-144">
                <Instagram size={20} data-id="element-145" />
              </a>
              <a href="#" className="w-10 h-10 rounded-sm bg-primary-light flex items-center justify-center hover:bg-accent hover:text-white transition-colors" data-id="element-146"></a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-147">
            <h4 className="text-lg font-serif font-bold mb-6 border-b border-primary-light pb-2 inline-block" data-id="element-148">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-149">
              <li data-id="element-150">
                <a href="#home" className="text-gray-400 hover:text-accent transition-colors" data-id="element-151">
                  Home
                </a>
              </li>
              <li data-id="element-152">
                <a href="#about" className="text-gray-400 hover:text-accent transition-colors" data-id="element-153">
                  About Us
                </a>
              </li>
              <li data-id="element-154">
                <a href="#services" className="text-gray-400 hover:text-accent transition-colors" data-id="element-155">
                  Services
                </a>
              </li>
              <li data-id="element-156">
                <a href="#projects" className="text-gray-400 hover:text-accent transition-colors" data-id="element-157">
                  Projects
                </a>
              </li>
              <li data-id="element-158">
                <a href="#testimonials" className="text-gray-400 hover:text-accent transition-colors" data-id="element-159">
                  Testimonials
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-160">
            <h4 className="text-lg font-serif font-bold mb-6 border-b border-primary-light pb-2 inline-block" data-id="element-161">
              Services
            </h4>
            <ul className="space-y-3" data-id="element-162">
              <li className="text-gray-400" data-id="element-163">Kitchen Remodeling</li>
              <li className="text-gray-400" data-id="element-164">Bathroom Remodeling</li>
              <li className="text-gray-400" data-id="element-165">Home Additions</li>
              <li className="text-gray-400" data-id="element-166">Permit Management</li>
              <li className="text-gray-400" data-id="element-167">Full Remodeling</li>
            </ul>
          </div>

          {/* Newsletter */}
        </div>

        <div className="border-t border-primary-light pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-168">
          
          <div className="flex gap-6 text-sm text-gray-500" data-id="element-169">
            
            
          </div>
        </div>
      </div>
    </footer>;
}